import {
  api,
  publicApi,
  PARTNER_TOKEN_KEY,
  PARTNER_EXPIRES_AT_KEY,
  PARTNER_POST_ID_KEY,
} from "./api";

// 협력 사이트(OCSPST) 양방향 링크 - 게스트 티켓

export interface PartnerExchangeResult {
  guestToken: string;
  postId: number;
  expiresAt: string;
}

/**
 * OCSPST 로 이동할 1회용 티켓 발급 (회원 전용)
 * @param ocspstLinkId 이동할 증례 링크 (게시글에 증례가 여러 건이면 필수)
 * @returns OCSPST 진입 주소 (실패 시 null → 호출부에서 원래 링크로 이동)
 */
export const issuePartnerTicket = async (
  postId: number,
  ocspstLinkId: number,
  password?: string
): Promise<string | null> => {
  try {
    const { data } = await api().post("/v1/partner-link/ticket", {
      postId,
      ocspstLinkId,
      ...(password ? { password } : {}),
    });
    return data.data?.entryUrl ?? null;
  } catch (e) {
    console.log(e);
    return null;
  }
};

/**
 * OCSPST 에서 받은 티켓을 게스트 토큰으로 교환 (인증 불필요)
 */
export const exchangePartnerTicket = async (ticket: string): Promise<PartnerExchangeResult> => {
  try {
    const { data } = await publicApi.post("/v1/partner-link/exchange", { ticket });
    return data.data;
  } catch (e: any) {
    const message = e?.response?.data?.message;
    throw new Error(message ?? "링크를 확인하지 못했습니다.");
  }
};

export const savePartnerGuestSession = (result: PartnerExchangeResult) => {
  sessionStorage.setItem(PARTNER_TOKEN_KEY, result.guestToken);
  sessionStorage.setItem(PARTNER_EXPIRES_AT_KEY, String(new Date(result.expiresAt).getTime()));
  sessionStorage.setItem(PARTNER_POST_ID_KEY, String(result.postId));
};
